import { render, staticRenderFns } from "./OrpModal.vue?vue&type=template&id=daf61b70"
import script from "./OrpModal.vue?vue&type=script&lang=js"
export * from "./OrpModal.vue?vue&type=script&lang=js"
import style0 from "./OrpModal.vue?vue&type=style&index=0&id=daf61b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports